/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_MusclesInputs */

const en_us2_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscles worked`)
};

const pt_br2_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos trabalhados`)
};

const es_419_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos trabajados`)
};

const pt_pt2_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos trabalhados`)
};

const fr_fr2_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscles sollicités`)
};

const de_de2_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beanspruchte Muskeln`)
};

const it_it2_exercise_muscles = /** @type {(inputs: Exercise_MusclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscoli coinvolti`)
};

/**
* | output |
* | --- |
* | "Muscles worked" |
*
* @param {Exercise_MusclesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_muscles = /** @type {((inputs?: Exercise_MusclesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_MusclesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_muscles(inputs)
	if (locale === "es-419") return es_419_exercise_muscles(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_muscles(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_muscles(inputs)
	if (locale === "de-DE") return de_de2_exercise_muscles(inputs)
	if (locale === "it-IT") return it_it2_exercise_muscles(inputs)
	return en_us2_exercise_muscles(inputs)
});
export { exercise_muscles as "exercise.muscles" }